/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import DownloadIcon from "../../Images/DownloadIcon";
import { ExtractReportContext } from "../ExtractReportContext";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ActionsKebab = ({
  failed,
  success,
  inprogress,
  queued,
  na,
  handleReturn,
  editLink,
  accountid,
  dagid,
  reportid
}) => {
  const { runReportKebab, runReportStatus, downloadReport } = useContext(
    ExtractReportContext
  );

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen(prevState => !prevState);

  return (
    <Dropdown
      className="actionsKebab"
      isOpen={dropdownOpen}
      toggle={toggle}
      setActiveFromChild
    >
      <DropdownToggle tabIndex="0" caret={false}>
        <svg
          width="5"
          height="17"
          viewBox="0 0 5 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.62746 4.34758C3.69337 4.34758 4.56547 3.45155 4.56547 2.35641C4.56547 1.26126 3.69337 0.365234 2.62746 0.365234C1.56156 0.365234 0.689453 1.26126 0.689453 2.35641C0.689453 3.45155 1.56156 4.34758 2.62746 4.34758ZM2.62746 6.33875C1.56156 6.33875 0.689453 7.23478 0.689453 8.32992C0.689453 9.42507 1.56156 10.3211 2.62746 10.3211C3.69337 10.3211 4.56547 9.42507 4.56547 8.32992C4.56547 7.23478 3.69337 6.33875 2.62746 6.33875ZM2.62746 12.3123C1.56156 12.3123 0.689453 13.2083 0.689453 14.3034C0.689453 15.3986 1.56156 16.2946 2.62746 16.2946C3.69337 16.2946 4.56547 15.3986 4.56547 14.3034C4.56547 13.2083 3.69337 12.3123 2.62746 12.3123Z"
            fill="#007DB8"
          />
        </svg>
      </DropdownToggle>
      <DropdownMenu>
        {failed && (
          <DropdownItem disabled>
            <ViewErrorDetailsIcon />
            View Error Details
          </DropdownItem>
        )}
        {inprogress || queued ? (
          <DropdownItem disabled>
            <RunIcon />
            Extract run in progress
          </DropdownItem>
        ) : (
          <DropdownItem
            disabled={runReportStatus === "loading" && true}
            onClick={() => runReportKebab(accountid, dagid, reportid)}
          >
            <RunIcon />
            {(na || success) && "Run Now"}
            {failed && "Retry Run"}
          </DropdownItem>
        )}
        <DropdownItem
          disabled={na}
          onClick={() =>
            handleReturn("Report Details", accountid, dagid, reportid)
          }
        >
          <SeeAllRunsIcon />
          Report Details
        </DropdownItem>
        <Link to={editLink} className="dropdown-item" tabIndex="0">
          <DropdownItem>
            <EditReportsIcon />
            Edit Report
          </DropdownItem>
        </Link>
        {success && (
          <DropdownItem
            onClick={() => downloadReport(accountid, dagid, reportid)}
          >
            <DownloadIcon />
            Download Last Run
          </DropdownItem>
        )}

        <DropdownItem
          onClick={() =>
            handleReturn("Delete Report", accountid, dagid, reportid)
          }
          className="dropdown-item"
          tabIndex="1"
        >
          <FontAwesomeIcon icon={faTrash} color="#0B78D0" />
          Delete Report
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

ActionsKebab.propTypes = {
  failed: PropTypes.bool,
  success: PropTypes.bool,
  inprogress: PropTypes.bool,
  queued: PropTypes.bool,
  na: PropTypes.bool,
  handleReturn: PropTypes.func.isRequired,
  editLink: PropTypes.string.isRequired,
  accountid: PropTypes.string,
  dagid: PropTypes.string,
  reportid: PropTypes.string
};

ActionsKebab.defaultProps = {
  failed: false,
  inprogress: false,
  queued: false,
  success: false,
  na: false,
  accountid: null,
  dagid: null,
  reportid: null
};

export default ActionsKebab;

const RunIcon = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3417 2.35C13.7527 0.9 11.572 0 9.15024 0C4.30666 0 0.394531 3.58 0.394531 8C0.394531 12.42 4.30666 16 9.15024 16C13.2377 16 16.6457 13.45 17.621 10H15.3417C14.4431 12.33 12.0104 14 9.15024 14C5.52303 14 2.57524 11.31 2.57524 8C2.57524 4.69 5.52303 2 9.15024 2C10.9693 2 12.5912 2.69 13.7747 3.78L10.2461 7H17.9169V0L15.3417 2.35Z"
        fill="#0B78D0"
      />
    </svg>
  );
};

const ViewErrorDetailsIcon = () => {
  return (
    <svg
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0C6 0 1.73 3.11 0 7.5C1.73 11.89 6 15 11 15C16 15 20.27 11.89 22 7.5C20.27 3.11 16 0 11 0ZM11 12.5C8.24 12.5 6 10.26 6 7.5C6 4.74 8.24 2.5 11 2.5C13.76 2.5 16 4.74 16 7.5C16 10.26 13.76 12.5 11 12.5ZM11 4.5C9.34 4.5 8 5.84 8 7.5C8 9.16 9.34 10.5 11 10.5C12.66 10.5 14 9.16 14 7.5C14 5.84 12.66 4.5 11 4.5Z"
        fill="#0B78D0"
      />
    </svg>
  );
};

const SeeAllRunsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 4H0V18C0 19.1 0.9 20 2 20H16V18H2V4ZM18 0H6C4.9 0 4 0.9 4 2V14C4 15.1 4.9 16 6 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM17 9H7V7H17V9ZM13 13H7V11H13V13ZM17 5H7V3H17V5Z"
        fill="#0B78D0"
      />
    </svg>
  );
};

const EditReportsIcon = () => {
  return (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.816406 13.4588V17H5.074L17.6311 6.55589L13.3735 3.01472L0.816406 13.4588ZM20.9236 3.81739C21.3664 3.4491 21.3664 2.85419 20.9236 2.4859L18.2669 0.276212C17.8241 -0.0920705 17.1088 -0.0920705 16.666 0.276212L14.5883 2.0043L18.8459 5.54548L20.9236 3.81739Z"
        fill="#0B78D0"
      />
    </svg>
  );
};

const DeleteIcon = () => {
  return (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M160 400C160 408.8 152.8 416 144 416C135.2 416 128 408.8 128 400V192C128 183.2 135.2 176 144 176C152.8 176 160 183.2 160 192V400zM240 400C240 408.8 232.8 416 224 416C215.2 416 208 408.8 208 400V192C208 183.2 215.2 176 224 176C232.8 176 240 183.2 240 192V400zM320 400C320 408.8 312.8 416 304 416C295.2 416 288 408.8 288 400V192C288 183.2 295.2 176 304 176C312.8 176 320 183.2 320 192V400zM317.5 24.94L354.2 80H424C437.3 80 448 90.75 448 104C448 117.3 437.3 128 424 128H416V432C416 476.2 380.2 512 336 512H112C67.82 512 32 476.2 32 432V128H24C10.75 128 0 117.3 0 104C0 90.75 10.75 80 24 80H93.82L130.5 24.94C140.9 9.357 158.4 0 177.1 0H270.9C289.6 0 307.1 9.358 317.5 24.94H317.5zM151.5 80H296.5L277.5 51.56C276 49.34 273.5 48 270.9 48H177.1C174.5 48 171.1 49.34 170.5 51.56L151.5 80zM80 432C80 449.7 94.33 464 112 464H336C353.7 464 368 449.7 368 432V128H80V432z"
        fill="#0B78D0"
      />
    </svg>
  );
};
